import { render } from "./z-categories-skelet.vue?vue&type=template&id=458fb526&scoped=true"
const script = {}

import "./z-categories-skelet.vue?vue&type=style&index=0&id=458fb526&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458fb526"]])

export default __exports__